import { ZmanimData } from '../types';
import { getCurrentTimeHHMM } from './timeUtils';

// Chronological order for display and for finding "what's next"
export const ZMAN_DISPLAY_FIELDS: { field: keyof ZmanimData; i18nKey: string }[] = [
  { field: 'AlotHashachar', i18nKey: 'alotHashachar' },
  { field: 'Sunrise', i18nKey: 'sunrise' },
  { field: 'ShemaMA', i18nKey: 'shemaMA' },
  { field: 'ShemaGra', i18nKey: 'shemaGra' },
  { field: 'Chatzot', i18nKey: 'chatzot' },
  { field: 'MinchaGedola', i18nKey: 'minchaGedola' },
  { field: 'MinchaKetana', i18nKey: 'minchaKetana' },
  { field: 'PlagHamincha', i18nKey: 'plagHamincha' },
  { field: 'SunsetDefault', i18nKey: 'sunsetDefault' },
  { field: 'Tzet', i18nKey: 'tzet' },
  { field: 'TzetRabbeinuTam', i18nKey: 'tzetRabbeinuTam' },
];

/** Returns the field name of the next zman that hasn't passed yet today, or null if all have. */
export function getUpcomingZmanField(zmanim: ZmanimData): string | null {
  const now = getCurrentTimeHHMM();
  for (const { field } of ZMAN_DISPLAY_FIELDS) {
    const time = zmanim[field] as string;
    if (time && time >= now) return field;
  }
  return null;
}
